import { ActionTree } from 'vuex'
import { RootState } from '@/store'
import { NarrowcastingState } from '@/store/narrowcasting/index'
import { CompanyAPI, WinckProxyAPI } from '@/api/backend-client'
import { WinckCollection, WinckOffice, WinckScheduledCollection, WinckScreen } from '@/api/client/winck-proxy'


export const actions: ActionTree<NarrowcastingState, RootState> = {
    async loadData({ commit }): Promise<void> {
        try {
            commit('loadData')
            const result = await Promise.all([
                WinckProxyAPI.getCollections(CompanyAPI.currentCompany),
                WinckProxyAPI.getScheduledCollections(CompanyAPI.currentCompany),
                WinckProxyAPI.getOffices(CompanyAPI.currentCompany),
                WinckProxyAPI.getFilterConfigs(CompanyAPI.currentCompany),
            ])
            const collections = result[0]
            const scheduledCollections = result[1]
            const offices = result[2]
            const filterConfigs = result[3]
            const screens = []

            for (const office of offices) {
                screens.push(... await WinckProxyAPI.getScreens(office.id))
            }

            commit('loadDataSuccess', { collections, scheduledCollections, offices, screens, filterConfigs })
            commit('sortData')

        } catch (error) {
            commit('loadDataFailure', error)
        }
    },

    async createCollection({ commit, dispatch }, collection: WinckCollection): Promise<void> {
        try {
            commit('createCollection')
            await WinckProxyAPI.createCollection(CompanyAPI.currentCompany, collection)
            commit('createCollectionSuccess', collection)
            commit('sortData')

        } catch (error) {
            commit('createCollectionFailure', error)
        }
    },
    async updateCollection({ commit, dispatch }, collection: WinckCollection): Promise<void> {
        try {
            commit('editCollection')
            await WinckProxyAPI.updateCollection(collection)
            commit('editCollectionSuccess', collection)
            commit('sortData')

        } catch (error) {
            commit('editCollectionFailure', error)
        }
    },
    async deleteCollection({ commit }, collection: WinckCollection): Promise<void> {
        try {
            commit('deleteCollection')
            await WinckProxyAPI.deleteCollection(collection.id)
            commit('deleteCollectionSuccess', collection)
            commit('sortData')

        } catch (error) {
            commit('deleteCollectionFailure', error)
        }
    },

    async createScheduledCollection({ commit, dispatch }, scheduledCollection: WinckScheduledCollection): Promise<void> {
        try {
            commit('createScheduledCollection')
            await WinckProxyAPI.createScheduledCollection(CompanyAPI.currentCompany, scheduledCollection)
            commit('createScheduledCollectionSuccess', scheduledCollection)
            commit('sortData')

        } catch (error) {
            commit('createScheduledCollectionFailure', error)
        }
    },
    async updateScheduledCollection({ commit, dispatch }, scheduledCollection: WinckScheduledCollection): Promise<void> {
        try {
            commit('editScheduledCollection')
            await WinckProxyAPI.updateScheduledCollection(scheduledCollection)
            commit('editScheduledCollectionSuccess', scheduledCollection)
            commit('sortData')

        } catch (error) {
            commit('editScheduledCollectionFailure', error)
        }
    },
    async deleteScheduledCollection({ commit }, scheduledCollection: WinckScheduledCollection): Promise<void> {
        try {
            commit('deleteScheduledCollection')
            await WinckProxyAPI.deleteScheduledCollection(scheduledCollection.id)
            commit('deleteScheduledCollectionSuccess', scheduledCollection)
            commit('sortData')

        } catch (error) {
            commit('deleteScheduledCollectionFailure', error)
        }
    },

    async createOffice({ commit, dispatch }, office: WinckOffice): Promise<void> {
        try {
            commit('createOffice')
            await WinckProxyAPI.createOffice(CompanyAPI.currentCompany, office)
            commit('createOfficeSuccess', office)
            commit('sortData')

        } catch (error) {
            commit('createOfficeFailure', error)
        }
    },
    async updateOffice({ commit, dispatch }, office: WinckOffice): Promise<void> {
        try {
            commit('editOffice')
            await WinckProxyAPI.updateOfficeName(office.id, office.name)
            commit('editOfficeSuccess', office)
            commit('sortData')

        } catch (error) {
            commit('editOfficeFailure', error)
        }
    },
    async deleteOffice({ commit }, office: WinckOffice): Promise<void> {
        try {
            commit('deleteOffice')
            await WinckProxyAPI.deleteOffice(office.id)
            commit('deleteOfficeSuccess', office)
            commit('sortData')

        } catch (error) {
            commit('deleteOfficeFailure', error)
        }
    },

    async createScreen({ commit, dispatch }, screen: WinckScreen): Promise<void> {
        try {
            commit('createScreen')
            await WinckProxyAPI.createScreen(screen)
            commit('createScreenSuccess', screen)
            commit('sortData')

        } catch (error) {
            commit('createScreenFailure', error)
        }
    },
    async updateScreen({ commit, dispatch }, screen: WinckScreen): Promise<void> {
        try {
            commit('editScreen')
            await WinckProxyAPI.updateScreen(screen)
            commit('editScreenSuccess', screen)
            commit('sortData')

        } catch (error) {
            commit('editScreenFailure', error)
        }
    },
    async deleteScreen({ commit }, screen: WinckScreen): Promise<void> {
        try {
            commit('deleteScreen')
            await WinckProxyAPI.deleteScreen(screen.id)
            commit('deleteScreenSuccess', screen)
            commit('sortData')

        } catch (error) {
            commit('deleteScreenFailure', error)
        }
    },
}
